import { render, staticRenderFns } from "./ImageWithBoundaryBox.vue?vue&type=template&id=6d585699"
import script from "./ImageWithBoundaryBox.vue?vue&type=script&lang=ts"
export * from "./ImageWithBoundaryBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports